import { Box, InputAdornment } from '@mui/material';
import { zodResolver } from '@hookform/resolvers/zod';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { Controller, useForm } from 'react-hook-form';
import { z as zod } from 'zod';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { readAdminId } from '@/api/asset/admin/read';
import { toast } from 'react-toastify';
import { Check } from '@mui/icons-material';
import { createAdminLogin } from '@/api/asset/admin/create';

const schema = zod.object({
  id: zod.string().min(1, { message: 'Click connect wallet' }),
  pw: zod.string().min(1, { message: 'Password is required' }),
  rePw: zod.string().min(1, { message: 'Password is required' }),
  code: zod.string().min(1, { message: 'Password is required' }),
});

type Values = zod.infer<typeof schema>;

const defaultValues = { pw: '', id: '', rePw: '', code: '' } satisfies Values;
export default function SignUp() {
  const [showPassword, setShowPassword] = useState<boolean>();
  const [showRePassword, setShowRePassword] = useState<boolean>();

  const [isIdCheck, setIsIdCheck] = useState<boolean>(false);

  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    setError,
    setValue,
    formState: { errors },
  } = useForm<Values>({ defaultValues, resolver: zodResolver(schema) });

  const onSubmit = async (data: Values) => {
    const re = await createAdminLogin(data);
    console.log(re);
    toast.error(re.message);
    if (re.status !== 200) {
      return;
    }
    navigate('/');
  };
  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Typography variant="h4">Sign Up</Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={2}>
          <Controller
            control={control}
            name="id"
            render={({ field }) => (
              <FormControl error={Boolean(errors.id)}>
                <InputLabel>id</InputLabel>
                <OutlinedInput
                  {...field}
                  label="id"
                  type="text"
                  endAdornment={
                    <InputAdornment position="end">
                      <Button
                        variant="contained"
                        onClick={async () => {
                          if (field.value === '') {
                            return;
                          }
                          const re = await readAdminId(field.value); // 입력된 id 값을 매개변수로 전달
                          toast.error(re.message);
                          if (re.data === null) {
                            setIsIdCheck(true);
                          } else {
                            setIsIdCheck(false);
                          }
                        }}
                      >
                        <Check /> {/* 원하는 아이콘 또는 컴포넌트 */}
                      </Button>
                    </InputAdornment>
                  }
                />
                {errors.id ? <FormHelperText>{errors.id.message}</FormHelperText> : null}
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name="pw"
            render={({ field }) => (
              <FormControl error={Boolean(errors.pw)}>
                <InputLabel>pw</InputLabel>
                <OutlinedInput {...field} label="Password" type={showPassword ? 'text' : 'password'} />
                {errors.pw ? <FormHelperText>{errors.pw.message}</FormHelperText> : null}
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name="rePw"
            render={({ field }) => (
              <FormControl error={Boolean(errors.rePw)}>
                <InputLabel>check pw</InputLabel>
                <OutlinedInput {...field} label="rePw" type={showRePassword ? 'text' : 'password'} />
                {errors.rePw ? <FormHelperText>{errors.rePw.message}</FormHelperText> : null}
              </FormControl>
            )}
          />
          <Controller
            control={control}
            name="code"
            render={({ field }) => (
              <FormControl error={Boolean(errors.code)}>
                <InputLabel>Code</InputLabel>
                <OutlinedInput {...field} label="code" type="text" />
                {errors.code ? <FormHelperText>{errors.code.message}</FormHelperText> : null}
              </FormControl>
            )}
          />
          {errors.root ? <Alert color="error">{errors.root.message}</Alert> : null}
          <Button disabled={!isIdCheck} type="submit" variant="contained">
            Sign in
          </Button>
        </Stack>
      </form>
    </Box>
  );
}
